"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var breadcrumbs_1 = require("../../components/common/breadcrumbs");
var season_list_1 = require("../../components/season/season-list");
var season_edit_1 = require("../../components/season/season-edit");
var season_1 = require("../../models/season");
var GqlProgramExpanded = require("../../core/gql/queries/program");
require("./seasons.scss");
var Seasons = function (_a) {
    var _b = _a.match.params, programId = _b.programId, orgId = _b.orgId;
    var _c = React.useState(null), selectedSeasonId = _c[0], setSelectedSeasonId = _c[1];
    var _d = React.useState(null), selectedActivitySeasonType = _d[0], setSelectedActivitySeasonType = _d[1];
    var _e = React.useState(false), shouldShowEditModal = _e[0], setShouldShowEditModal = _e[1];
    var showSeason = function (type, id) {
        setSelectedSeasonId(id);
        setSelectedActivitySeasonType(type);
        setShouldShowEditModal(true);
    };
    if (!programId)
        return null;
    return (React.createElement("div", { id: "seasons", className: "container" },
        React.createElement(react_apollo_1.Query, { query: GqlProgramExpanded.QUERY, variables: { programId: parseInt(programId) } }, function (_a) {
            var data = _a.data, loading = _a.loading;
            if (loading)
                return null;
            var program = data === null || data === void 0 ? void 0 : data.showProgram;
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "page-content u-xs-padMd u-sm-spaceTopLg u-flexExpandSides" },
                    React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                        React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                            React.createElement(breadcrumbs_1.default, { breadcrumbs: [
                                    {
                                        text: "Programs",
                                        link: "/organizations/" + orgId + "/programs",
                                    },
                                    { text: program.name },
                                ] }),
                            React.createElement("p", null, program.description)),
                        React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-textRight" },
                            React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: "plus", iconPosition: "left", onClick: function () { return showSeason(season_1.ActivitySeasonType.ClubSeason, null); } }, "Create New Season"))),
                    React.createElement("div", { className: "page-content-body" },
                        React.createElement(season_list_1.default, { selectSeasonIdCallback: showSeason, program: program }))),
                shouldShowEditModal && React.createElement(season_edit_1.default, { program: program, isOpen: shouldShowEditModal, onClose: function () { return setShouldShowEditModal(false); }, selectedSeasonId: selectedSeasonId, activitySeasonType: selectedActivitySeasonType }));
        })));
};
exports.default = Seasons;
//# sourceMappingURL=seasons.js.map